import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "@/app/store";
import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { ReasonsForDelete } from "@/components/profile/delete-account/ReasonsForDelete";

import deleteAccountImg from "@/assets/profile/delete-account.svg";

export const Route = createFileRoute("/dashboard/profile/delete-account/")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: DeleteAccount,
});

function DeleteAccount() {
  const { t } = useTranslation();
  const { data } = useAppSelector((state) => state.provider);
  const providerName = data?.personalData?.firstname;

  return (
    <div className="pb-8">
      <SectionRoute
        route_one={t("routes.dashboard")}
        route_two={t("routes.profile")}
        route_two_link="/dashboard/profile"
        route_three={t("routes.delete_account")}
      />
      <div className="mb-8 max-w-7xl mx-auto">
        <HeadingOne>{`${providerName ? providerName : "Hey"} ${t("profile.delete_account.title")}`}</HeadingOne>
        <div className="grid grid-cols-9 gap-8 items-center mt-6">
          <div className="col-span-5 flex flex-col gap-4">
            <Paragraph>{t("profile.delete_account.subtitle")}</Paragraph>
            <ReasonsForDelete />
          </div>
          <div className="col-span-4 flex items-center justify-center">
            <img src={deleteAccountImg} alt="" className="self-center" />
          </div>
        </div>
      </div>
    </div>
  );
}
